// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__X63Nc","infoBtn":"quickbooks_infoBtn__1mtBD","formBox":"quickbooks_formBox__2kpZt","formFooter":"quickbooks_formFooter__1XMX9"};